import { useCallback, useState } from "react";
import { Library } from "./library/Library.js";
import { Workspace } from "./workspace/Workspace.js";
import { ColoringWorkspace } from "./coloring/ColoringWorkspace.js";
import type { ProjectType } from "./lib/types.js";

/**
 * Top-level routing. The home is the book Library; opening a book switches to
 * its Workspace — the manuscript workspace for novels, or the coloring-book
 * workspace for coloring books. (Per-book dashboard info lives inside each
 * workspace as its Overview section.)
 */
export function App() {
  const [active, setActive] = useState<{ id: string; type: ProjectType } | null>(null);

  const openBook = useCallback((id: string, type: ProjectType) => setActive({ id, type }), []);
  const goLibrary = useCallback(() => setActive(null), []);

  if (active?.type === "coloring") {
    return <ColoringWorkspace key={active.id} projectId={active.id} onGoLibrary={goLibrary} />;
  }

  if (active) {
    return (
      <Workspace
        key={active.id}
        projectId={active.id}
        initialSceneId={null}
        onGoDashboard={goLibrary}
        onProjectChanged={async () => { /* library reloads when shown */ }}
      />
    );
  }

  return <Library onOpenBook={openBook} />;
}
